// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Anastasia Chesnovskaya <anastasia.chesnovskaya@celadon.ae>

import createReducer from '../../../store/createReducer';
import * as types from './actionTypes';

const initialState = {
  fundraiseForm: {
    PaymentType: 2,
    CharityName: null,
    CharityNumber: null,
    TradingName: null,
    CharityURL: null,
    contactemail: null,
    ContactNumber: null,
    ContactName: null,
    AccountholderName: null,
    BankAccountNumber: null,
    BankSortCode: null,
  },
  status: null,
  error: null,
  isButtonPressed: false,
  data: {},
};

const fundraiseReducer = createReducer(initialState, {
  [types.SET_FUNDRAISE_FORM_FIELD](state, action) {
    return {
      ...state,
      fundraiseForm: {
        ...state.fundraiseForm,
        [action.field]: action.value,
      },
    };
  },
  [types.RESET_ERROR](state) {
    return {
      ...state,
      error: initialState.error,
    };
  },
  [types.VALIDATE_PHONE_NUMBER_FUNDRAISE](state) {
    return {
      ...state,
    };
  },
  [types.VALIDATE_BANK_ACCOUNT](state) {
    return {
      ...state,
    };
  },
  [types.SET_ERROR](state, action) {
    return {
      ...state,
      error: action.error,
    };
  },
  [types.SET_IS_BUTTON_PRESSED](state, action) {
    return {
      ...state,
      isButtonPressed: action.isButtonPressed,
    };
  },
  [types.GET_FUNDRAISE_PAGE_DATA](state) {
    return {
      ...state,
    };
  },
  [types.GET_FUNDRAISE_PAGE_DATA_SUCCESS](state, action) {
    return {
      ...state,
      data: {
        ...action.data,
      },
    };
  },
  [types.REGISTER_CHARITY](state) {
    return {
      ...state
    };
  },
  [types.REGISTER_CHARITY_SUCCESS](state) {
    return {
      ...state,
      status: true,
      fundraiseForm: initialState.fundraiseForm,
    };
  },
  [types.RESET_STATUS](state) {
    return {
      ...state,
      status: initialState.status,
    };
  },
});

export default fundraiseReducer;
